import { getDb } from '../db';
import type { Category } from '../../core/types';

export const categoryRepo = {
  async all(): Promise<Category[]> {
    const db = await getDb();
    return (await db.getAll('categories')).sort((a, b) => a.order - b.order);
  },

  async get(id: string): Promise<Category | undefined> {
    const db = await getDb();
    return db.get('categories', id);
  },

  async upsert(category: Category): Promise<void> {
    const db = await getDb();
    await db.put('categories', category);
  },

  /** Destructive → PIN-gated at the surface. The Notfall category is locked (1.10). */
  async remove(id: string): Promise<void> {
    const db = await getDb();
    const existing = await db.get('categories', id);
    if (existing?.locked) throw new Error(`refusing to delete locked category ${id}`);
    await db.delete('categories', id);
  },
};
